module.exports = __webpack_public_path__ + "static/petshop-def32fd39e735a5535329a7adf40bcf4.png";